var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.595553 5.64821C0.76144 5.80723 0.985842 5.89648 1.21975 5.89648C1.45365 5.89648 1.67805 5.80723 1.84394 5.64821L5.02246 2.62576L8.15671 5.64821C8.3226 5.80723 8.547 5.89648 8.7809 5.89648C9.01481 5.89648 9.23921 5.80723 9.4051 5.64821C9.48808 5.56883 9.55395 5.4744 9.5989 5.37036C9.64385 5.26632 9.66699 5.15472 9.66699 5.04201C9.66699 4.9293 9.64385 4.8177 9.5989 4.71366C9.55395 4.60961 9.48808 4.51518 9.4051 4.43581L5.65108 0.815703C5.56877 0.735678 5.47085 0.67216 5.36296 0.628814C5.25507 0.585467 5.13934 0.56315 5.02246 0.56315C4.90558 0.56315 4.78986 0.585467 4.68196 0.628814C4.57407 0.67216 4.47615 0.735678 4.39384 0.815703L0.595554 4.43581C0.512568 4.51518 0.446701 4.60961 0.401751 4.71366C0.356801 4.8177 0.333658 4.9293 0.333658 5.04201C0.333658 5.15472 0.356801 5.26632 0.401751 5.37036C0.446701 5.4744 0.512568 5.56883 0.595553 5.64821Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow-up-icon.91d045b67cbb81e5a911d22388bef92e.svg";
export { ForwardRef as ReactComponent };